import React from 'react';
import cn from 'classnames';
import Details from './components/Details/Details';
import ShortDetails from './components/ShortDetails/ShortDetails';
import TotalRefund from './components/TotalRefund/TotalRefund';
import { useTheme } from '../../../../../theme';
import { CheckinCard } from '@shared/CheckinCard';
const ExchangeRefundPriceDetails = ({ className, prices, variant = 'details', ticketPrice, additionalPrices }) => {
    const { ExchangeRefundPriceDetails: theme } = useTheme('Entities').Order.ExchangeRefundPriceDetails;
    return (React.createElement(CheckinCard, { className: cn(theme.root, className) },
        variant === 'details' && React.createElement(Details, { prices: prices, additionalPrices: additionalPrices }),
        variant === 'short-details' && React.createElement(ShortDetails, { prices: prices, ticketPrice: ticketPrice }),
        variant === 'only-total' && React.createElement(TotalRefund, { price: prices.priceToPay })));
};
export default ExchangeRefundPriceDetails;
